/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import DOMPurify from "dompurify";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSettingApi } from "../../../Features/Setting/Setting";
import { Col, Row } from "antd";

function SettingPage() {
  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting?.settingData);

  useEffect(() => {
    dispatch(getSettingApi());
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Row justify="center">
        <Col xs={22} md={22} lg={22} xl={22} xxl={22}>
          <div style={{ textAlign: "start", marginBottom: "80px" }}>
            <p
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(setting?.app_terms_condition || "") }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default SettingPage;
